import { AppRouter } from '../AppRouter'

function App() {
  // Full-screen portals (super-admin, tenant) manage their own layout.
  // Render them without the generic app shell so they can fill 100vh correctly.
  const isPortalRoute =
    window.location.pathname.startsWith('/admin') ||
    (window.location.pathname !== '/' &&
      window.location.pathname !== '/login/complete' &&
      window.location.pathname !== '/verify');

  if (isPortalRoute) {
    return <AppRouter />;
  }

  return (
    <div className="app">
      <AppRouter />
    </div>
  );
}

export default App
